module.exports = __webpack_public_path__ + "img/icon_muban.8ce920bd.png";